import { defineComponent, ref, onMounted } from 'vue';
import sys from '@truckdown/jsclient';

interface Review {
    content: string,
    name: string
}

export default defineComponent({
    props: {
        reviews: {
            type: Array as () => Review[],
            required: true
        }
    },
    setup: function (props, ctx) {

        const currentIndex = ref<number>(0);
        let reviews = ref<Review[]>(props.reviews);

        const nextSlide = function() {
            currentIndex.value++;
            if (currentIndex.value >= props.reviews.length) {
                currentIndex.value = 0;
            }
        }

        const prevSlide = function () {
            currentIndex.value--;
            if (currentIndex.value < 0) {
                currentIndex.value = props.reviews.length - 1;
            }
        }

        const randomize = function (array: Review[]): Review[] {
            for (let i = array.length - 1; i > 0; i--) {
                const j = Math.floor(Math.random() * (i + 1));
                [array[i], array[j]] = [array[j], array[i]];
            }
            return array;
        }


        return {
            nextSlide,
            prevSlide,
            currentIndex,
            reviews,
            randomize
        }
    }
});


